import { render, staticRenderFns } from "./ImportarRepasses.vue?vue&type=template&id=22059018&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./ImportarRepasses.vue?vue&type=style&index=0&id=22059018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22059018",
  null
  
)

export default component.exports